export const GET_CONTACT_US = "GET_CONTACT_US";
export const GET_CONTACT_US_FAILURE = "GET_CONTACT_US_FAILURE";
export const GET_CONTACT_US_SUCCESS = "GET_CONTACT_US_SUCCESS";

 